<template>
  <b-card class="custom-card">
    <div :id="downloadId" class="container-line-chart bg-dark-blue" :style="this.sizeOfContainer">
      <div class="watermark disp-none"></div>
      <b-card-header style="padding-bottom: 12px;">
        <div class="card-text-strong transparent">
          <span class="card-management-title transparent text-white" style="font-size=14px">{{ titleChart }} </span>
          <i
            class="fa fa-info-circle help-icon remove-elem-download"
            v-if="titleTooltip != ''"
            v-b-tooltip.hover="{
              placement: tooltipPlacement,
              title: titleTooltip,
              html: tooltipHtmlContent
            }"
          />
          <slot name="header"></slot>
        </div>
        <slot name="subheader"></slot>
      </b-card-header>
      <slot name="body"></slot>
      <div>
        <div class="d-none download-info" v-if="isZoomEnabled && zoomGraphValueChild">
          <div class="d-flex justify-content-between">
            <div :class="`info-text-word-cloud ml-12 ${isZoomEnabled && zoomGraphValueChild ? 'zoom fs-12' : 'pdingstyle'}`">
              This visualization is powered by one or more of THREAD’s proprietary algorithms, which, as trade secrets, are
              <br />afforded robust legal protections and may not be used in any manner without the prior written consent of THREAD.
            </div>
            <div class="ml-20">
              <img src="@/assets/white-thread_logo_tm.png" :class="`${isZoomEnabled && zoomGraphValueChild ? 'mr-15 mt-8 pr-15' : 'mr-15 mt-0 littlepading pr-15'}`" :height="`${isZoomEnabled && zoomGraphValueChild ? '24' : '13'}`" />
            </div>
          </div>
        </div>
        <div class="d-none download-info" v-else>
          <div class="d-flex justify-content-between">
            <div :class="`info-text-word-cloud ml-12 ${isZoomEnabled && zoomGraphValueChild ? 'zoom fs-12' : 'pdingstyle'}`">
              This visualization is powered by one or more of THREAD’s proprietary algorithms,<br />
              which, as trade secrets, are afforded robust legal protections and may not be used<br />
              in any manner without the prior written consent of THREAD.
            </div>
            <div class="ml-20">
              <img src="@/assets/white-thread_logo_tm.png" :class="`${isZoomEnabled && zoomGraphValueChild ? 'mr-15 mt-8 pr-15' : 'mr-15 mt-20 littlepading pr-15'} `" :height="`${isZoomEnabled && zoomGraphValueChild ? '24' : '16'}`" />
            </div>
          </div>
        </div>
        <div class="text-right">
          <span class="remove-elem-download">
            <img v-show="showThreadLogoInUnexpand || (isZoomEnabled && zoomGraphValueChild && downloadShow)" src="@/assets/white-thread_logo_tm.png" class="pr-11 pb-11" height="35" />
            <span class="pr-10" v-if="downloadShow">
              <img src="static/img/download-graphs.png" class="download_graph cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" />
              <div class="dropdown-menu download-dropdown-box p-0 dropdown-menu-right">
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadCSVGraphs()"><img src="/static/img/csv.svg" class="mr-6" />CSV</span>
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadPDFGraphs()"><img src="/static/img/pdf.svg" class="mr-6" />PDF</span>
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadPNGGraphs()"><img src="/static/img/img.svg" class="mr-6" />PNG</span>
              </div>
            </span>

            <span @click="zoomGraph(true)" class="cursor_pointer pr-20" title="Expand" v-if="isZoomEnabled && !zoomGraphValueChild && downloadShow">
              <img src="/static/img/expandbox.svg" class="download_graph" />
            </span>
            <span @click="zoomGraph(false)" class="cursor_pointer pr-20" v-if="isZoomEnabled && zoomGraphValueChild && downloadShow" title="Collapse">
              <img src="/static/img/unexpand.svg" class="download_graph" />
            </span>
          </span>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { getSiteID } from "../../services/visualization/data-management";

export default {
  props: {
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    specificSiteId: [Object, Array],
    onCSVDownload: { type: Function, default: null },
    onPNGDownload: { type: Function, default: null },
    onPDFDownload: { type: Function, default: null },
    isZoomEnabled: { type: Boolean, default: true },
    downloadShow: { type: Boolean, default: false },
    titleTooltip: { type: String, default: "" },
    tooltipHtmlContent: { type: Boolean, default: false },
    tooltipPlacement: { type: String, default: "rightbottom" },
    showThreadLogoInUnexpand: { type: Boolean, default: false }
  },
  data() {
    return {
      type: "line",
      dataFormat: "json",
      renderAt: "chart-container",
      width: "100%",
      height: "250",
      zoomGraphValueChild: "",
      getSiteID,
      sizeOfContainer: null
    };
  },

  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
      this.updateSizeOfContainer();
    },
    downloadShow: function(newVal) {
      this.downloadShow = newVal;
      this.updateSizeOfContainer();
    }
  },
  mounted() {
    this.updateSizeOfContainer();
  },
  methods: {
    updateSizeOfContainer() {
      if (this.downloadShow) {
        if (this.isZoomEnabled && this.zoomGraphValueChild) {
          this.sizeOfContainer = "height: 470px;";
        } else {
          this.sizeOfContainer = "height: 325px;";
        }
      } else {
        this.sizeOfContainer = "height: 325px;";
      }
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "450";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "300";
        this.$emit("zoomDisabled");
      }
    },
    downloadPNGGraphs() {
      if (this.onPNGDownload) {
        this.$emit("onPNGDownload");
        return;
      }
      this.download("png");
    },
    downloadPDFGraphs() {
      if (this.onPDFDownload) {
        this.$emit("onPDFDownload");
        return;
      }

      this.download("pdf");
    },
    download(type) {
      const todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      const container = document.querySelector("#" + this.downloadId);
      let filename = this.titleChart + "_" + todayDate + "." + type;
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        filename = this.titleChart + "_" + todayDate + "_" + getSiteID(this.specificSiteId[0]) + "." + type;
      }
      html2canvas(container, {
        allowTaint: true,
        logging: false,
        height: !this.zoomGraphValueChild ? 450 : 650,
        scrollY: -window.scrollY,
        useCORS: true,
        scrollX: -window.scrollX,
        onclone: document => {
          if (this.isZoomEnabled && this.zoomGraphValueChild) {
            document.querySelectorAll(".bg-gradient-blue").forEach(el => el.classList.add("download"));
          } else {
            document.querySelectorAll(".bg-gradient-blue").forEach(el => el.classList.add("downloads"));
          }
          document.querySelectorAll(".download-info").forEach(el => el.classList.remove("d-none"));
          document.querySelector("#" + this.downloadId + " .watermark").classList.remove("disp-none");
          if (this.specificSiteId && this.specificSiteId.length > 0) {
            if (document.querySelector("#" + this.downloadId + " .title-date") != null) {
              document.querySelector("#" + this.downloadId + " .title-date").append("_" + this.getSiteID(this.specificSiteId[0]));
            } else {
              document.querySelector("#" + this.downloadId + " .card-management-title").append("_" + this.getSiteID(this.specificSiteId[0]));
            }
          }
          document.querySelectorAll("#" + this.downloadId + " .custom-tooltip").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .apexcharts-toolbar").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-elem-download").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-zoom-icons").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .nav-item").forEach(element => {
            const ele = element.querySelector(".nav-link.active");
            if (!ele) {
              element.remove();
            }
          });
          if (!this.zoomGraphValueChild) {
            const dateTime = document.createElement("div");
            dateTime.classList.add("ml-12", "mt-9", "fs-11");
            dateTime.textContent = todayDate;
            dateTime.style.color = "#b0bac9";
            document.querySelector("#" + this.downloadId).append(dateTime);
            if (document.querySelectorAll(".table-content").length > 0) {
              document.querySelectorAll(".table-content")[0].className = "remove-overflow";
            }
            if (document.querySelectorAll(".rtl-display").length > 0) {
              document.querySelectorAll(".rtl-display")[0].className = "ltr-display";
            }
          } else {
            const dateTime = document.createElement("div");
            dateTime.classList.add("ml-12", "mt-9", "fs-18");
            dateTime.textContent = todayDate;
            dateTime.style.color = "#b0bac9";
            document.querySelector("#" + this.downloadId).append(dateTime);
            if (document.querySelectorAll(".table-content").length > 0) {
              document.querySelectorAll(".table-content")[0].className = "remove-overflow";
            }
            if (document.querySelectorAll(".rtl-display").length > 0) {
              document.querySelectorAll(".rtl-display")[0].className = "ltr-display";
            }
          }
        }
      }).then(canvas => {
        if (type === "pdf") {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jspdf("p", "mm", "a4");
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth - 0, pdfHeight);
          pdf.save(filename);
        } else if (type === "png") {
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.download = filename;
          link.href = canvas.toDataURL("image/png");
          link.target = "_blank";
          link.click();
        }
      });
    },
    downloadCSVGraphs() {
      this.$emit("onCSVDownload"); //
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
  padding-bottom: 50px;
  height: 313px;
}

.bg-dark-blue {
  background-color: #243e64;
}

.info-text-word-cloud {
  color: #b0bac9;
  font-size: 8px;

  &.zoom {
    font-size: 12px;
  }
}

.custom-card {
  border: 0px;
}

.pdingstyle {
  padding-top: 1.5px;
}

.littlepading {
  padding-top: 0px;
}

.watermark {
  content: "";
  background-image: url(/static/img/thread-white-tm.png);
  background-size: 250px;
  display: block;
  background-repeat: space;
  width: 500%;
  height: 500%;
  position: absolute;
  top: -380%;
  left: -88%;
  display: block;
  transform: rotate(-30deg);
  opacity: 0.1;
}

.disp-none {
  display: none;
}

.transparent {
  background-color: transparent;
}

.bg-gradient-blue {
  .help-icon {
    color: #d9d9d9;
  }

  .bg-dark-blue {
    background: linear-gradient(180deg, #657892 0%, #253f65 100%) !important;
    border-radius: 4px;
  }

  .card-body.transparent {
    padding: 0 !important;
  }

  &.download {
    .bg-dark-blue {
      height: 500px !important;
      background: #243e64 !important;
    }
  }

  &.downloads {
    .bg-dark-blue {
      height: 399px !important;
      background: #243e64 !important;
    }
  }
}
</style>
